import { render, staticRenderFns } from "./RequisitionApproverList.vue?vue&type=template&id=2a1a6e00&"
import script from "./RequisitionApproverList.vue?vue&type=script&lang=ts&"
export * from "./RequisitionApproverList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports